module.exports = __webpack_public_path__ + "static/media/27OCHA3.47f8e845.jpg";